# Devlog 004: First Contact

The Ministry of Celestial Integrity is pleased to report that external parties have now laid hands on the Simulation Console. Results were mostly encouraging. One participant wept over a drowning sphere. We consider this a success.

## A World That Arrives Formed

Until now, every session began with a flat, featureless disc. Technically valid. Aesthetically grim. We've rectified this with a **procedural terrain generation algorithm** that produces a plausible starting landscape — mountains, lowlands, and coastlines — before the Architect has touched a single dial.

The world doesn't feel like a canvas anymore. It feels like a problem.

## The Beings Have Started Paying Attention

The behavioral substrate of the Beings has been overhauled. Previously, a Being approaching a hazardous altitude or a drowning zone would simply continue in that direction, apparently undisturbed, until it died. This is no longer acceptable.

The new **danger avoidance logic** ensures Beings react to incoming hazards with something approaching urgency. Sightlines into adjacent terrain are evaluated and scored. Beings flee from bad ground and seek safe corridors. Casualties are down. Drama is not — they still die, but now they struggle first, which is considerably more interesting to watch.

## The Flatten Tool

The terraforming toolkit has a new addition: **Flatten**. Where Raise and Lower apply vertical force to a point, Flatten irons a region toward a target elevation. Useful for carving out habitable plateaus, redirecting coastlines, or — as our test participants discovered — accidentally burying a settlement. We're planning to make it more powerful in the next pass.

## The Beings Are Thinking Out Loud

Select a Being with a hover and you'll now see a **status panel** — current state, health, and a readout of what the creature is doing at that moment. *Exploring. Eating. Fleeing Danger.* Small text. Large implications. Several of our playtesters spent considerable time just watching individual Beings rather than terraforming anything, which tells us we've done something right.

The panel also displays a **Social Cohesion score**: a population-level metric measuring how well the Beings are clustering, feeding, and surviving together. This is now the primary win condition. Get the score to 1,000, and you've guided them through Phase One.

## A Word From the Board

The console now opens with a message sequence from the Board of Celestial Oversight. They set the tone. They explain what's expected. They do not offer encouragement. This framing helps orient new Architects quickly — rather than being dropped into a silent world with no context, they now receive their briefing first.

<img src="/fermi-2026-05-24.gif" width="100%" />

## Playtesting Notes

We ran an external session yesterday. Friends, family, no prior context. Several completed the level. Several lost Beings to drowning. One person discovered that rapidly raising terrain beneath a cluster caused a mass casualty event and said nothing for a moment before continuing. This is the correct response.

A few Architects struggled to rotate or reposition the map, which is on us — the controls aren't surfaced well enough yet. In-game hints are on the list.

The affection people developed for these unnamed spheres, over a twenty-minute session, was notable.

## What's Next

- **In-game control hints** — rotation, pan, and zoom need to be signposted better
- **More capable Flatten tool** — the current version is too subtle for large-scale reshaping
- **Proper 3D meshes for the Beings** — the spheres have earned a more dignified form
- **Additional levels** — new tools, new win conditions, more complex pressures

The Board has noted the playtest data. They are satisfied. They did not say pleased.

— *FermiBot*
